import { Box, useMediaQuery } from '@material-ui/core';
import React, { useState } from 'react';
import { BooleanInput, required, SelectInput, TextInput } from 'react-admin';
import { isExpGui, telValidationDest, telValidationExp } from '../references.js';

const marginRight ={marginRight:10};

const  Customer =(props,...rest) => {

    const [isAlreadyClient, setIsAlreadyClient] = useState(false);
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const {permissions,listFretDisponible}=props;

    var validationPhoneExp=isExpGui(permissions) ? telValidationDest:telValidationExp;
    var validationPhoneDest=isExpGui(permissions) ? telValidationExp:telValidationDest;
  
  return (
    <>
        <Box display="flex"    fullWidth justifyContent="space-btween" flexWrap="wrap">
            <SelectInput source="camp_id"  choices={listFretDisponible} 
                initialValue={listFretDisponible[0].id} validate={required()}  label="Campange" 
                style={isSmall ? null:{width:'58%',marginRight:30}}  
                fullWidth
            />
            <BooleanInput  source="urgent" fullWidth label="Urgent" style={isSmall ? null:{width:'38%',marginTop:15}}  />
        </Box>  

        <Box display="flex"    fullWidth justifyContent="space-btween" flexWrap="wrap">
        {isSmall ? <TextInput  source="nom_exp" fullWidth label="Nom expéditaire"  style ={isSmall ? null:marginRight} validate={required()}   /> :
                    <TextInput  source="nom_exp"  label="Nom expéditaire"  style ={isSmall ? null:marginRight} validate={required()}   /> 
        }
        {isSmall ? <TextInput source="tel_exp1" fullWidth label="Telephone expéditaire 1*"  style ={isSmall ? null:marginRight} validate={[validationPhoneExp]}  />:
                    <TextInput source="tel_exp1" label="Telephone expéditaire 1*"  style ={isSmall ? null:marginRight} validate={[validationPhoneExp]}  />
        }
        {isSmall ? null:<TextInput source="tel_exp2"  label="Telephone expéditaire 2"  style ={marginRight}   />}
        {isSmall ? null:<TextInput source="email_exp"  label="Email expéditaire"  style ={marginRight}  />}
        {isSmall ?  <TextInput source="adresse_exp"  fullWidth label="Adresse expéditaire"   /> : 
                    <TextInput source="adresse_exp"  label="Adresse expéditaire"   />}
        </Box>  

        <Box display="flex"    fullWidth justifyContent="space-btween" flexWrap="wrap">
        {isSmall ?<TextInput  source="nom_dest" fullWidth label="Nom destinataire"  style ={isSmall ? null:marginRight} validate={required()}   />:
                    <TextInput  source="nom_dest"  label="Nom destinataire"  style ={isSmall ? null:marginRight} validate={required()}   />
        }
        {isSmall ?<TextInput source="tel_dest1" fullWidth label="Telephone destinataire 1*"  style ={isSmall ? null:marginRight} validate={[validationPhoneDest]}  />:
                    <TextInput source="tel_dest1"  label="Telephone destinataire 1*"  style ={marginRight} validate={[validationPhoneDest]}  />
        }
        {isSmall ? null:<TextInput source="tel_dest2"  label="Telephone destinataire 2"  style ={marginRight}  />}
        {isSmall ? null:<TextInput source="email_dest"  label="Email destinataire"  style ={marginRight}  />}
        {isSmall ? <TextInput fullWidth source="adresse_dest"  label="Adresse destinataire"   />:
                    <TextInput source="adresse_dest"  label="Adresse destinataire"   />}
            </Box>  
    </>
    );
};

export default Customer;
